import React, { useEffect } from 'react';
import styled from 'styled-components';
import { PrimaryBtn } from '@panel/commons/lib/Button';
import NewsImg from '@panel/commons/assets/img/news.svg';
import { sendTrackingInfo, sendCustomTrackingInfo } from '@panel/commons';

const TourModal = ({
  device,
  onClose,
  setShowTour,
  onCloseTourInModal,
  title,
  textInfo,
  textInfo2,
  textPrimaryCTA,
  withSkiptCTA = false,
  padding,
  withoutStartingTour = false
}) => {
  useEffect(() => {
    if (device === 'desktop') {
      sendCustomTrackingInfo({
        event: 'impression_modal',
        content_group: 'Mis avisos',
        modal_name: 'Modal de bienvenida tour virtual'
      });
    }
  }, [device]);

  const startTour = () => {
    onClose();
    if (!withoutStartingTour) {
      setShowTour(true);
      sendTrackingInfo('Panel', 'Mis avisos', 'Tour virtual-Comienza el recorrido_Siguiente');
    }
  };

  return (
    <Container padding={padding}>
      <Img data-panel='panel-modal-tour-img' src={NewsImg} />
      <div>
        <h3 data-panel='panel-modal-tour-title'>{title}</h3>
        <p data-panel='panel-modal-tour-text'>{textInfo}</p>
        <p data-panel='panel-modal-tour-text2'>{textInfo2}</p>
      </div>
      <div className='button-container'>
        <PrimaryBtn
          dataPanel='panel-modal-tour-cta-start'
          type='submit'
          onClick={startTour}
          borderRadius='8px'
          hoverColor='secondary'
        >
          {textPrimaryCTA}
        </PrimaryBtn>
        {withSkiptCTA && (
          <div
            data-panel='panel-modal-tour-cta-close'
            className='close-button'
            onClick={onCloseTourInModal}
            aria-hidden='true'
          >
            Omitir
          </div>
        )}
      </div>
    </Container>
  );
};

const Container = styled.div`
  padding: ${({ padding }) => padding || '28px'};
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .button-container {
    width: 100%;
    .close-button {
      font-family: Hind;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px;
      letter-spacing: 0em;
      text-align: center;
      padding-top: 16px;
      cursor: pointer;
      width: fit-content;
      margin: auto;
    }
  }

  h3 {
    font-family: Hind;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: center;
    white-space: normal;
    margin-bottom: 10px;
  }
  p {
    font-family: Hind;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: center;
    white-space: normal;
    margin: auto;
    max-width: 311px;
  }

  > a {
    height: 48px;
  }
`;

const Img = styled.div`
  background-image: url(${({ src }) => src});
  width: 227px;
  height: 235px;
`;

export default TourModal;
